import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
    Page,
    LayoutSingleColumn,
    LayoutWrapperTopbar,
    LayoutWrapperMain,
    LayoutWrapperFooter,
    Footer,
} from '../../components';
import { SectionHero, SectionSuperDeals } from '../LandingPage/sectionsSuperDeals';
import { TopbarContainer } from '../../containers';
import css from './LandingPageSuperDeals.css';
import { ensureCurrentUser } from '../../util/data';
import { getLpSchemaObj, facebookImages, twitterImages } from '../LandingPage/common/helpers';

export const LandingPageSuperDeals = ({
    scrollingDisabled,
    currentUser,
    currentUserRequestInProgress,
}) => {
    const schemaTitle = 'SuperDeals  | HorseDeal';
    const schemaDescription =
        'Hier findest Du wöchentlich neue Gutscheine und Rabatte deiner Lieblingsmarken. Mehr erfahren.';

    return (
        <Page
            scrollingDisabled={scrollingDisabled}
            contentType="website"
            description={schemaDescription}
            title={schemaTitle}
            facebookImages={facebookImages}
            twitterImages={twitterImages}
            schema={getLpSchemaObj(schemaTitle, schemaDescription)}
        >
            <LayoutSingleColumn>
                <LayoutWrapperTopbar>
                    <TopbarContainer />
                </LayoutWrapperTopbar>
                <LayoutWrapperMain
                    className={css.layout}
                    blobBackground
                    blobProps={{
                        xDistance: 20,
                        baseWidth: 760,
                    }}
                >
                    <main className={css.container}>
                        <SectionHero />
                        {!currentUserRequestInProgress && (
                            <SectionSuperDeals currentUser={currentUser} />
                        )}
                    </main>
                </LayoutWrapperMain>
                <LayoutWrapperFooter>
                    <Footer />
                </LayoutWrapperFooter>
            </LayoutSingleColumn>
        </Page>
    );
};

const { bool } = PropTypes;

LandingPageSuperDeals.propTypes = {
    scrollingDisabled: bool.isRequired,
};

const mapStateToProps = ({ user: { currentUser, currentUserRequestInProgress }, UI }) => ({
    currentUser: ensureCurrentUser(currentUser),
    scrollingDisabled: isScrollingDisabled({ UI }),
    currentUserRequestInProgress,
});

export default compose(connect(mapStateToProps))(LandingPageSuperDeals);
